import { Alert, AlertTitle, Typography, Link as MuiLink } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

type Props = {
  companyName: string;
  customerId: string;
};

export function MoreInvoicesAlert({ companyName, customerId }: Props) {
  return (
    <Alert severity="info">
      <AlertTitle>More Invoices Available</AlertTitle>
      <Typography>
        See all open invoices for this customer.&nbsp;
        <MuiLink component={Link} to={`/chasables/search?input=${companyName}&value=${customerId}&showBackButton=true`}>
          See all invoices
        </MuiLink>
      </Typography>
    </Alert>
  );
}
